import { TextButtonPriority, TextButton, } from '../../TextButton';
class AvatarGroupTextButton extends TextButton {
}
AvatarGroupTextButton.defaultProps = {
    priority: TextButtonPriority.secondary,
};
export { AvatarGroupTextButton };
//# sourceMappingURL=AvatarGroupTextButton.js.map